module.exports = __webpack_public_path__ + "static/img/bl_1.22c2d51.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/mainBusiness/bl_1.png
// module id = fz+u
// module chunks = 0